module.exports = __webpack_public_path__ + "img/navigate_after_white_32px.92d85012.png";